import React from 'react';
import { Row, Space, Button, Divider } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Permission } from '../../components';
import './style';

export default React.forwardRef((props, ref) => {
  const { onOk, onCloseCallback, setUserPermissions, createrId, ownerId, users, permissions } = props;
  
  const onChange = (checked, userId, permissionId) => {
    setUserPermissions(checked, userId, permissionId);
  }

  return (
    <div style={{ padding: '1rem 0' }} >
        {
          (users || []).map((item) => {
            return <Row>
              <Permission
                creater={item.id === createrId}
                owner={item.id === ownerId}
                permissions={permissions}
                onChange={onChange}
                user={item} />
            </Row>
          })
        }
        <Divider />
        <Row justify="start">
          <Space size="large">
            <div style={{ marginLeft: 'auto' }}></div>
            <Button onClick={onCloseCallback} icon={<CloseOutlined />}>关 闭</Button>
            <Button onClick={onOk} type="primary" icon={<CheckOutlined />}>确 定</Button>
          </Space>
        </Row>
    </div>
  );
});
